import { render } from "./ForumDetailModal.vue?vue&type=template&id=a233e846&scoped=true"
import script from "./ForumDetailModal.vue?vue&type=script&lang=js"
export * from "./ForumDetailModal.vue?vue&type=script&lang=js"

import "./ForumDetailModal.vue?vue&type=style&index=0&id=a233e846&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a233e846"]])

export default __exports__